import React from 'react';
import { motion } from 'framer-motion';
import { GiWeightLiftingUp } from 'react-icons/gi';
import { FaFlask, FaMobileAlt, FaDumbbell } from 'react-icons/fa';

class Expertise extends React.Component {
  render() {
    return (
      <section className="py-16 bg-gray-100">
        <div className="max-w-6xl mx-auto px-4">
          <h2 className="text-3xl font-bold text-center mb-12">
            Por Que Diego Trainer Gera Resultados
          </h2>
          
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            {/* Cartão 1 */}
            <motion.div 
              className="bg-white p-8 rounded-xl shadow-lg"
              whileHover={{ y: -10 }}
            >
              <GiWeightLiftingUp className="text-blue-500 text-4xl mb-4" />
              <h3 className="text-xl font-bold mb-4">12+ Anos Treinando Clientes</h3>
              <p className="text-gray-600">
                Especializado em condicionamento metabólico e perda de peso sustentável
              </p>
            </motion.div>

            {/* Cartão 2 */}
            <motion.div 
              className="bg-white p-8 rounded-xl shadow-lg"
              whileHover={{ y: -10 }}
            >
              <FaFlask className="text-blue-500 text-4xl mb-4" />
              <h3 className="text-xl font-bold mb-4">Planos Baseados na Ciência</h3>
              <p className="text-gray-600">
                Programas que combinam HIIT, treinamento de força, dieta sustentável e protocolos de recuperação
              </p>
            </motion.div>

            {/* Cartão 3 */}
            <motion.div 
              className="bg-white p-8 rounded-xl shadow-lg"
              whileHover={{ y: -10 }}
            >
              <FaMobileAlt className="text-blue-500 text-4xl mb-4" />
              <h3 className="text-xl font-bold mb-4">Seu Plano, Seu Celular</h3>
              <p className="text-gray-600">
              Treine no seu tempo e horário, de qualquer lugar, com acompanhamento personalizado e evolução garantida — tudo pelo seu celular
              </p>
            </motion.div>
          </div>

          {/* Botão de CTA Adicionado */}
          <motion.div 
            className="flex justify-center items-center text-center mt-12"
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8 }}
          >
            <motion.a
              href="https://training-app.short.gy/train-with-diego-trainer"
              target="_blank"
              rel="noopener noreferrer"
              whileHover={{ scale: 1.05 }}
              className="bg-blue-500 hover:bg-blue-600 text-white font-bold py-4 px-12 rounded-lg flex items-center gap-3 text-lg"
            >
              <FaDumbbell className="text-xl" />
              Comece Sua Transformação
            </motion.a>
          </motion.div>
        </div>
      </section>
    );
  }
}

export default Expertise;
